<script setup lang="ts">
import ServiceSettingEdit from "@/views/playground/planner/order-management/service-setting/ServiceSettingEdit.vue";
</script>
<template>
  <service-setting-edit></service-setting-edit>
</template>
<style scoped></style>
